import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from "react-redux";
import store from "./store/Store";

import App from './App';


//import { I18nextProvider } from 'react-i18next';
import './localization/i18n'

//import {Theme, Header} from 'ktr-materialui-react'
//<ThemeProvider theme={Theme.whiteKTRTheme}>

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <Provider store={ store }>
        <App />
    </Provider>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
